import React from 'react';

class ManualAddressForm extends React.Component {
  render() {
    const {
      handleAddressLine1Change,
      handleAddressLine2Change,
      handleAddressLine3Change,
      handleAddressLine4Change,
      handlePostCodeChange,
      line1,
      line2,
      line3,
      line4,
      postcode,
    } = this.props;

    return (
      <div className="fl-on fl-jc-sb input-address">
        <div className="fl-fb-50">
          <label htmlFor="input-address-one">
            Address <strong className="required">*</strong>
          </label>
          <input
            onChange={handleAddressLine1Change}
            type="text"
            value={line1}
            autoComplete="off"
            name="line_1"
            id="input-address-one"
          />
          <input
            onChange={handleAddressLine2Change}
            type="text"
            aria-label="line_2"
            value={line2}
            autoComplete="off"
            name="line_2"
          />

          <label htmlFor="input-town">
            Town <strong className="required">*</strong>
          </label>
          <input
            onChange={handleAddressLine3Change}
            type="text"
            value={line3}
            autoComplete="off"
            name="line_3"
            id="input-town"
          />

          <label htmlFor="input-county">County</label>
          <input
            onChange={handleAddressLine4Change}
            type="text"
            value={line4}
            autoComplete="off"
            name="line_4"
            id="input-county"
          />

          <label htmlFor="input-postcode">
            Postcode <strong className="required">*</strong>
          </label>
          <input
            onChange={handlePostCodeChange}
            type="text"
            value={postcode}
            autoComplete="off"
            name="postcode"
            id="input-postcode"
          />
        </div>
      </div>
    );
  }
}

export default ManualAddressForm;
